import { DataViewerUtil } from '@leverege/molten/data-viewers'
import { Attributes, ItemCard } from '@leverege/ui-attributes'
import { Content, Pane, Text } from '@leverege/ui-elements'
import { Toolbar } from '@leverege/ui-plugin'
import React from 'react'

import moment from 'moment'
import S from './StationsCardDataViewer.css'

export default function StationCardDataViewer( props ) {
  const {
    paginator,
    settings : model,
    objectType,
    relationship,
    inCard,
    actions,
  } = props

  const { path } = relationship

  const actionBarMatchContext = {
    use : 'actionBar',
    client : StationCardDataViewer.CLIENT,
    objectType,
    path,
  }

  const context = {
    client : StationCardDataViewer.CLIENT,
    clientProps : props,
  }

  const content = (
    <Toolbar
      className={S.toolbar}
      variant="actionBar"
      prefer="icon"
      matchContext={actionBarMatchContext}
      context={context}/>
  )

  return (
    <Content className={S.content}>
      <Content.Header layout="flex:rowMEnd">
        <DataViewerUtil.HeaderToolbar inCard={inCard} content={content} />
      </Content.Header>
      <Content.Area>
        <Pane variant="stationGrid" className={S.stations}>
          {paginator.pageItems
            .sort( ( a, b ) => ( moment( a?.data?.data?.lastService ).isBefore(
              b?.data?.data?.lastService,
            ) ? 1 : -1 )
            )
            .map( item => (
              <ItemCard
                key={item.id}
                model={model}
                variant="customItemContent"
                controls={<Occupied item={item} actions={actions} />}
                context={{
                  id : item.id,
                  target : [ item ],
                }}/>
            )
            )} 
        </Pane>
      </Content.Area>
    </Content>
  )
}

function Occupied( { item, actions } ) {
  const occupied = Attributes.get( 'station.occupied', item )
  const variant = occupied ? 'pillOccupied' : 'pillEmpty'
  const text = occupied ? 'In Use' : 'Available'

  return (
    <Text
      variant={variant}>
      {text}
    </Text>
  )
}

StationCardDataViewer.CLIENT = 'StationCardDataViewer'
